import IAppEvents from './IAppEvents';
import IAppLogger from './IAppLogger';

abstract class AppModule {
  protected app: { events: IAppEvents; logger: IAppLogger };
  constructor(events: IAppEvents, logger: IAppLogger) {
    this.app = { events, logger };
  }
  public events: string[] = [];
  public preload() {}
  public load() {}
}

export default AppModule;
